import { normalizePhone } from '@repo/utils/normalizePhone';

function parsePhoneNumber(phoneNumber) {
  const e164 = normalizePhone(phoneNumber);
  const national = `${phoneNumber}`.replace(/\D/g, '');
  const match = /^(\d{3})(\d{3})(\d{4})$/.exec(national);

  if (match) {
    return {
      // Return the formatted string
      formatNational: () => `(${match[1]}) ${match[2]}-${match[3]}`,
      // Return the URI
      getURI: () => `tel:${e164}`,
    };
  }
  // If the input is not of correct length return the original string
  return {
    formatNational: () => phoneNumber,
    getURI: () => `tel:${phoneNumber}`,
  };
}

export default parsePhoneNumber;
